<template>
  <div class="card spaceship-preview">
    <div v-if="spaceship.drawing && spaceship.drawing.image" class="card-image">
      <figure class="image is-4by3">
        <img :src="spaceship.drawing.image" :alt="spaceship.name">
      </figure>
    </div>
    <div class="card-content">
      <p class="title is-5">
        <router-link :to="{ name: 'hangarShip', params: { id: spaceship.id } }">
          {{ spaceship.name }}
        </router-link>
      </p>
      <div class="content">
        <p v-if="spaceship.drawing">
          <strong>Чертёж:</strong> {{ spaceship.drawing.name }}
        </p>
        <p v-if="spaceship.strength != null">
          <strong>Прочность:</strong> {{ spaceship.strength }}
        </p>
        <p v-if="spaceship.volume != null">
          <strong>Объём:</strong> {{ spaceship.volume }}
        </p>
        <p>
          <strong>Слотов:</strong> {{ spaceship.connectors_count }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    spaceship: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.spaceship-preview {
  margin-bottom: 1rem;
}
</style>
